/**
 * @generated SignedSource<<de2f38f0fe9c8415d765a17f160a6798>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type PutIdentityResponseError =
  | 'APPLICATION_IN_PROGRESS'
  | 'BIRTHDAY_INVALID'
  | 'BIRTHDAY_NOT_PROVIDED'
  | 'EMAIL_NOT_PROVIDED'
  | 'EMPLOYER_NOT_PROVIDED'
  | 'IDENTITY_NOT_FOUND'
  | 'INSTITUTION_LINK_ACCESS_TOKEN_NOT_PROVIDED'
  | 'INVALID_PHONE_NUMBER'
  | 'INVALID_SSN'
  | 'NAME_NOT_PROVIDED'
  | 'PHONE_NUMBER_NOT_PROVIDED'
  | 'UNAUTHORIZED'
  | '%future added value';
export type CreditFrozenPageMutation$variables = {
  identityId: string;
};
export type CreditFrozenPageMutation$data = {
  readonly putIdentity: {
    readonly data: {
      readonly syncTaskId: string | null;
    } | null;
    readonly errors: ReadonlyArray<PutIdentityResponseError>;
  };
};
export type CreditFrozenPageMutation = {
  response: CreditFrozenPageMutation$data;
  variables: CreditFrozenPageMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'identityId',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                fields: [
                  {
                    kind: 'Variable',
                    name: 'id',
                    variableName: 'identityId',
                  },
                  {
                    kind: 'Literal',
                    name: 'socialSecurityNumbers',
                    value: [
                      {
                        entity: {
                          sync: true,
                        },
                      },
                    ],
                  },
                ],
                kind: 'ObjectValue',
                name: 'identity',
              },
            ],
            kind: 'ObjectValue',
            name: 'q',
          },
        ],
        concreteType: 'PutIdentityResponseValidation',
        kind: 'LinkedField',
        name: 'putIdentity',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'PutIdentityResponse',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'syncTaskId',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'CreditFrozenPageMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'CreditFrozenPageMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '590a06215198f3d68d81d8a9069f7226',
      id: null,
      metadata: {},
      name: 'CreditFrozenPageMutation',
      operationKind: 'mutation',
      text: 'mutation CreditFrozenPageMutation(\n  $identityId: String!\n) {\n  putIdentity(q: {identity: {id: $identityId, socialSecurityNumbers: [{entity: {sync: true}}]}}) {\n    data {\n      syncTaskId\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'e28e2263196dcbd2767cfebfca854199';

export default node;
